export default __webpack_public_path__ + "static/media/selected-icon.95f3dbc6.png";